import { ChangeDetectionStrategy, Component, computed, inject, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog } from '@angular/material/dialog';
import {
  PageWrapper,
  RolloutPlanStore,
  UnsavedChangesGuardedComponent,
  useRolloutPlanStore
} from '@ottobock/remote-update/domain';

import { CreateRolloutPlan } from '../rollout-plan-modal/create-rollout-plan';
import { RolloutPlanTableComponent } from '../rollout-plan-table/rollout-plan-table.component';

@Component({
  selector: 'remote-update-feature-remote-update-dashboard-rollout-plan',
  imports: [RolloutPlanTableComponent, PageWrapper, MatButtonModule],
  templateUrl: './rollout-plan.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './rollout-plan.css'
})
export class RolloutPlan implements UnsavedChangesGuardedComponent, OnInit {
  readonly dialog = inject(MatDialog);
  store = inject(useRolloutPlanStore);
  rolloutPlanFormStore = inject(RolloutPlanStore);
  emptyTitle = 'No rollout plan available';
  emptyDescription = 'Please create a rollout plan';

  data = computed(() => {
    const result = this.store.rolloutPlan().data;
    if (!result) return [];
    return Array.isArray(result) ? result : [result];
  });
  hasError = computed(() => this.store.rolloutPlan().error !== null);
  isLoading = computed(() => this.store.rolloutPlan().loading);

  backRedirectRoute = '/rollout-plan';

  get hasUnsavedChanges() {
    return this.rolloutPlanFormStore.isFormDirty();
  }

  ngOnInit(): void {
    this.store.loadRolloutPlan();
  }
  openDialog() {
    this.rolloutPlanFormStore.resetFormData();
    const dialogRef = this.dialog.open(CreateRolloutPlan, {
      width: '100%',
      maxWidth: '100%',
      height: '100%',
      data: { name: 'John Doe' },
      disableClose: true,
      closeOnNavigation: false,
      panelClass: 'no-radius-dialog'
    });

    dialogRef.afterClosed().subscribe(() => {
      this.rolloutPlanFormStore.resetFormData();
    });
  }
}
